<template>
  <b-container>
    <b-row class="headline" align-v="start" v-if="album">
      <b-col cols="12" sm="9">
        <AlbumCard :album="album" :showArtist="true" />
      </b-col>
      <b-col cols="12" sm="3" class="text-right">
        <Pay :album="album"></Pay>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="video" class="player-col">
        <Player v-model="video"
                :videos="songs"
                :position.sync="position"
                :autoplay="true"
                :pageUrl="$route.fullPath"></Player>
      </b-col>
    </b-row>

    <VideoInfo :video="video" v-if="video" />

    <b-row v-if="filteredRelated.length">
      <b-col>
        <h4>More albums</h4>
      </b-col>
    </b-row>

    <b-row align-v="start" v-for="relatedAlbum in filteredRelated" :key="relatedAlbum.id" class="py-2">
      <b-col cols="12" sm="9">
        <AlbumCard :album="relatedAlbum" :showArtist="true" />
      </b-col>
      <b-col cols="3" class="text-right">
        <Pay :album="relatedAlbum" v-if="isNotOwner(relatedAlbum)"></Pay>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 2em;
    max-width: unset;
  }

  .headline {
    margin-bottom: 1em;
  }

  .buy-related {
    display: none;
  }

  @include media-breakpoint-up(sm) {
    .buy-related {
      display: block;
    }
  }

  button.btn-rainbow {
    font-size: 0.8em;
    padding: 0.5em 2em 0.5em 2em;
  }

</style>

<script>
import { mapGetters } from 'vuex'
import filter from 'lodash/filter'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Player from '@/components/widgets/Player'
import VideoInfo from '@/components/widgets/VideoInfo'
import AlbumCard from '@/components/widgets/AlbumCard'
import Pay from '@/components/widgets/Pay'

import { songHelpers, profileHelpers } from '@/store/helpers'

export default {
  name: 'AlbumDetail',
  components: {
    FontAwesomeIcon,
    Player,
    VideoInfo,
    AlbumCard,
    Pay
  },
  data () {
    return {
      album: null,
      related: [],
      position: 0,
      video: null
    }
  },
  computed: {
    songs () {
      if (!this.album) return []
      return this.album.songs || []
    },
    numVideos () {
      if (this.songs.length === 0) return 'no songs'
      if (this.songs.length === 1) return '1 song'
      return this.songs.length + ' songs'
    },
    filteredRelated () {
      if (!this.album) return this.related
      return filter(this.related, album => this.album.id !== album.id)
    },
    ...mapGetters('profile', ['currentUser', 'isArtist']),
    ...mapGetters('artist', ['artist'])
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData',
    'position': 'updateQueryString'
  },
  methods: {
    async fetchData () {
      const params = this.$route.params
      const query = this.$route.query
      if (this.album && this.album.id === params.id) return

      try {
        this.album = await this.$store.dispatch('song/getAlbum', {id: params.id})
      } catch (e) {
        let message = 'Error getting album information'
        if (e.response && e.response.status === 404) message = 'Album no longer exists'
        this.$store.dispatch('flash/showMessage', { message, type: 'error' })
        this.$router.replace({'name': 'discover'})
        return
      }

      for (let song of this.album.songs) {
        song.artist = this.album.artist
      }

      this.position = +query.pos || 0
      this.video = (this.songs.length > 0) ? this.songs[this.position % this.songs.length] : null

      const filter = query.related ? { related: query.related } : { artist_id: this.album.artist.id }
      const relatedResponse = await this.$store.dispatch('song/listAlbums', filter)

      // If we have related album IDs, we want all the results, otherwise just a first batch is fine
      this.related = query.related ? await relatedResponse.all() : relatedResponse.results
    },
    isNotOwner (album) {
      return !this.isArtist || album.artist.id !== this.artist.id
    },
    updateQueryString () {
      const route = this.$route

      if (this.position === +route.query.pos) return

      const query = { ...route.query }
      query.pos = this.position

      this.$router.push({
        name: route.name,
        meta: route.meta,
        params: { id: this.album.id },
        query: query
      })
    },
    ...songHelpers,
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/AlbumDetail.vue